import styled from 'styled-components'

export const MessageContainer = styled.div`
  padding: ${props => props.theme.spacing.sp24};
  background-color: ${props => props.theme.colors.background.primary};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.radius.card};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.radius.card};
  overflow: hidden;
`

export const SubjectHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const EmailFrame = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.sp40} ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.palette.greyNeutral.tone300};
`
